import src from "IMAGE";
export default { src, width: 284, height: 70, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAM0lEQVR42i3IoRIAEBQF0fdXjCaJJIEoaYb/n2vDC2fDmqSJhIyAgoWGbuRg+IioeNi4H9yRNR0GtjHvAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 2 }
